import React, { useState } from "react";
import { Button, Table, Form, Popover, OverlayTrigger } from "react-bootstrap";
import { EmpReport } from "../types/EmpReport";
import "../styles/EmployeeList.css";
import { Edit, Trash } from "lucide-react";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { LocalFormatDate } from "../config/functions";

type Props = {
  empReportList: EmpReport[];
  onEdit?: (report: EmpReport) => void;
  onDelete: (id: number) => void;
  onView: (report: EmpReport) => void;
  onStatusToggle?: (report: EmpReport) => void;
};

const EmployeeReportList: React.FC<Props> = ({
  empReportList,
  onEdit,
  onDelete,
  onStatusToggle,
}) => {
  const projects = useSelector((state: StoreState) => state.project);
  const tasks = useSelector((state: StoreState) => state.task);
  const user = useSelector((state: StoreState) => state.authUser);

  const getProjectNameById = (projectId: number): string => {
    const project = projects.find((p) => p.id === projectId);
    return project ? project.name : "Unknown Project";
  };
  const getTaskById = (taskId: number): string => {
    const task = tasks.find((t) => t.id === taskId);
    return task ? task.title : "unknown Task";
  };

  const totalHoursSpent = empReportList.reduce(
    (sum, item) => sum + Number(item.hoursSpent),
    0,
  );

  const filterEmpId =
    user.role === "User"
      ? empReportList.filter((e) => e.employeeId === user.employeeId)
      : empReportList;

  const editPopover = (
    <Popover id="popover-edit">
      <Popover.Body>Edit Details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-delete">
      <Popover.Body>Delete Details</Popover.Body>
    </Popover>
  );
  console.log(empReportList);

  return (
    <>
      <Table className="custom-employee-table" responsive>
        <thead>
          <tr>
            <th>S.No</th>
            {user.role === "Admin" && <th>Employee ID</th>}

            <th>Date</th>
            <th>Project</th>
            <th>Task</th>
            <th>Activity</th>
            <th>Hours Spent</th>
            <th>Status</th>
            {user.role === "User" && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {filterEmpId.map((report, index) => (
            <tr key={report.id}>
              <td>{index + 1}</td>
              {user.role === "Admin" && <td>{report.employeeId}</td>}
              <td>{LocalFormatDate(report.date)}</td>
              <td>{getProjectNameById(report.projectId)}</td>
              <td>{getTaskById(report.taskId)}</td>
              <td>{report.activity}</td>
              <td>{report.hoursSpent}</td>
              {user.role === "Admin" && (
                <td>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={report.status === "Approved"}
                      onChange={() => onStatusToggle?.(report)}
                    />
                    <span className="slider" />
                  </label>
                </td>
              )}

              {user.role === "User" && (
                <>
                  <td>
                    <span>
                      {report.status === "Approved" ? "Approved" : "Pending"}
                    </span>
                  </td>
                  <td>
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="top"
                      overlay={editPopover}
                    >
                      <Button
                        variant="success"
                        className={`btn btn-sm text-white  ${
                          report.status === "Approved" ? "disabled-gray" : ""
                        }`}
                        style={{
                          padding: "5px",
                          borderRadius: "5px",
                          marginRight: "5px",
                        }}
                        onClick={() => onEdit?.(report)}
                        disabled={report.status === "Approved"}
                      >
                        <Edit style={{ width: "20px" }} />
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="top"
                      overlay={deletePopover}
                    >
                      <Button
                        variant="danger"
                        className={`btn btn-sm text-white  ${
                          report.status === "Approved" ? "disabled-gray" : ""
                        }`}
                        style={{
                          padding: "5px",
                          borderRadius: "5px",
                          marginRight: "5px",
                          border: "none",
                        }}
                        onClick={() => onDelete(report.id)}
                        disabled={report.status === "Approved"}
                      >
                        <Trash style={{ width: "20px" }} />
                      </Button>
                    </OverlayTrigger>
                  </td>
                </>
              )}
            </tr>
          ))}
          {user.role === "Admin" && (
            <tr style={{ fontWeight: "bold" }}>
              <td colSpan={6}>Total Hours Spent</td>
              <td style={{ textAlign: "left" }}>{totalHoursSpent}</td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};

export default EmployeeReportList;
